import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";
import ProfilePicture from "@Shared/components/settings/account/profile-picture.vue";
import ChangePassword from "@Shared/components/settings/account/change-password.vue";
import ChangeBrokerage from "./change-brokerage.vue";
import AccountPreferences from "./account-preferences.vue";
import LanguagePreferences from "@Shared/components/settings/account/language-preferences.vue";
import ProfileContainerLoader from "./profile-container-loader.vue";
import { UPDATE_ACCOUNT_DETAILS, UPDATE_ACCOUNT_PREFERENCES, UPDATE_BROKERAGE_SUBDOMAIN, UPDATE_PROFILE_PHOTO, REMOVE_PROFILE_PHOTO, UPDATE_LOCALE_PREFERENCES } from "@Broker/@Modules/main/store/account/account-actions";
import { UPDATE_PASSWORD } from "@Broker/@Modules/settings/store/settings-actions";
import { showToast } from "@Shared/utils/constants";
import { Fragment } from "vue-fragment";
import { defineComponent } from "@vue/composition-api";
import { clearDashboardCache } from "@Broker/@Modules/dashboard/store/dashboard-actions";
export default defineComponent({
  name: "ProfileContainer",
  components: {
    ProfilePicture,
    ChangePassword,
    ChangeBrokerage,
    AccountPreferences,
    LanguagePreferences,
    ProfileContainerLoader,
    Fragment
  },
  props: {
    saving: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      formsWaiting: 0,
      newDomain: "",
      loading: false,
      formsChanged: [],
      formsWithError: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("AccountStore", ["accountDetails", "permissions", "accountPreferences", "userDetails"])), {}, {
    session() {
      return this.data.session;
    },
    subdomain() {
      return this.data.accountDetails.accountSubdomain;
    }
  }),
  watch: {
    formsWaiting(newValue, oldValue) {
      if (oldValue !== 0 && newValue === 0) {
        if (!this.formsWithError.length) showToast("success", "profileUpdated");
        this.loading = false;
        if (this.newDomain) {
          location.replace(`${this.newDomain}#/personal-settings`);
        }
        this.$nextTick(() => {
          this.$refs.changePasswordForm.clearPasswords();
        });
      }
    },
    saving(value) {
      if (!value) return;
      this.handleSubmit();
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("AccountStore", [UPDATE_ACCOUNT_DETAILS, UPDATE_ACCOUNT_PREFERENCES, UPDATE_BROKERAGE_SUBDOMAIN, UPDATE_PROFILE_PHOTO, REMOVE_PROFILE_PHOTO, UPDATE_LOCALE_PREFERENCES])), mapActions("SettingsStore", [UPDATE_PASSWORD])), {}, {
    handleSubmit() {
      this.loading = true;
      this.formsChanged.forEach(async form => await this.$refs[`${form}Form`].handleSubmit());
      this.formsChanged = [];
      this.formsWithError = [];
      this.$emit("finish-saving", true);
    },
    async handleBrokerageSubmit(accountSubdomain) {
      try {
        var _context;
        this.newDomain = accountSubdomain;
        this.formsWaiting++;
        await this.UPDATE_BROKERAGE_SUBDOMAIN(accountSubdomain);
        this.formsWithError = _filterInstanceProperty(_context = this.formsWithError).call(_context, form => form !== "changeBrokerage");
      } catch (e) {
        this.formsWithError.push("changeBrokerage");
      } finally {
        this.formsWaiting--;
      }
    },
    async handlePasswordSubmit(passwords) {
      try {
        var _context2;
        this.formsWaiting++;
        await this.UPDATE_PASSWORD(_objectSpread(_objectSpread({}, passwords), {}, {
          email: this.userDetails.email
        }));
        this.formsWithError = _filterInstanceProperty(_context2 = this.formsWithError).call(_context2, form => form !== "changePassword");
      } catch (e) {
        this.formsWithError.push("changePassword");
      } finally {
        this.formsWaiting--;
      }
    },
    async handleAccountPreferencesSubmit(accountPreferences) {
      try {
        var _context3;
        const includeExistingChanged = this.accountPreferences.includeExisting !== accountPreferences.includeExisting;
        const data = _objectSpread(_objectSpread({}, this.accountPreferences), {}, {
          tutorial: accountPreferences.tutorial,
          includeExisting: accountPreferences.includeExisting
        });
        this.formsWaiting++;
        await this.UPDATE_ACCOUNT_PREFERENCES(data);
        clearDashboardCache();
        if (includeExistingChanged) {
          sessionStorage.setItem("reloadMortgageRenewalsWithSpinner", "true");
        }
        this.formsWithError = _filterInstanceProperty(_context3 = this.formsWithError).call(_context3, form => form !== "accountPreferences");
      } catch (e) {
        this.formsWithError.push("accountPreferences");
      } finally {
        this.formsWaiting--;
      }
    },
    async handleLanguagePreferencesSubmit(languagePreferences) {
      try {
        var _context4;
        this.formsWaiting++;
        await this.UPDATE_LOCALE_PREFERENCES(languagePreferences);
        this.formsWithError = _filterInstanceProperty(_context4 = this.formsWithError).call(_context4, form => form !== "languagePreferences");
      } catch (e) {
        this.formsWithError.push("languagePreferences");
      } finally {
        this.formsWaiting--;
      }
    },
    async handleUploadProfilePhoto(croppedImage) {
      this.formsWaiting++;
      this.loading = true;
      await this.UPDATE_PROFILE_PHOTO({
        croppedImage,
        username: this.userDetails.username
      });
      this.formsWaiting--;
    },
    async handleRemoveProfilePhoto() {
      this.formsWaiting++;
      this.loading = true;
      await this.REMOVE_PROFILE_PHOTO();
      this.formsWaiting--;
    },
    handleFormChange(form) {
      var _context5;
      if (!_includesInstanceProperty(_context5 = this.formsChanged).call(_context5, form)) this.formsChanged.push(form);
    },
    handleAllowSave(allowSave) {
      this.$emit("allow-save", this.formsChanged.length && allowSave);
    }
  })
});